import raw from "../emoji.json";

/** One category tab: `recent` first, then the categories in picker order. */
export interface EmojiCategoryInfo {
    id: string;
    label: string;
    icon: string;
}

/** One emoji: the character, its name (what search matches), its category and the skin-tone variants (light to dark). */
export interface EmojiEntry {
    e: string;
    n: string;
    c: string;
    t?: string[];
}

export interface EmojiData {
    columns: number;
    maxRecent: number;
    categories: EmojiCategoryInfo[];
    toneLabels: string[];
    toneSwatches: string[];
    emoji: EmojiEntry[];
}

/** Shared with the desktop apps: Shared/emoji/emoji.json. */
export const EMOJI: EmojiData = raw as EmojiData;
